<template>
  <div key="version1.0.3">
    <ajax-intercept @start="start" @finish="finish"></ajax-intercept>

    <barra-navegacao
      :autenticado="auth"
      :rotas="routes"
      :usuario="usuarioLogado.primeiroNome"
      :sshd="usuarioLogado.sshd"
    ></barra-navegacao>
    <barra-menu
      class="hidden-xs hidden-sm"
      v-show="auth"
      :rotas="routes"
      :declaracaoVisitada="declaraVisited"
      :avaliacaoVisitada="avaliaVisited"
      :recadastramentoVisitada="recadastraVisited"
      :formulariosVisitada="formulariosVisited"
      :feriasVisitada="feriasVisited"
      :valeAlimentacaoVisitada="valeAlimentacaoVisited"
    ></barra-menu>
    <barra-evolucao
      v-show="stepVisible"
      :stepOne="number"
      :stepTwo="number"
      :stepThree="number"
      :stepFour="number"
      :stepFive="number"
      :stepSix="number"
      :stepSeven="number"
      :textOne="number"
      :textTwo="number"
      :textThree="number"
      :textFour="number"
      :textFive="number"
      :textSix="number"
      :textSeven="number"
      :contentNumber="number"
      :contentName="stepName"
    ></barra-evolucao>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <rodape v-show="auth" id="footer" />
    <botao-ir-para-topo></botao-ir-para-topo>
    <transition name="fade" mode="out-in">
      <loader v-if="carregando"></loader>
    </transition>
  </div>
</template>

<script>
import rodape from '@/components/rodape';
import BotaoIrParaTopo from '@/components/botao-ir-para-topo';
import AjaxIntercept from 'vue-ajax-intercept';
import Loader from '@/components/loader';
import BarraNavegacao from '@/components/barra-navegacao';
import BarraEvolucao from '@/components/barra-evolucao';
import BarraMenu from '@/components/barra-menu';

export default {
  name: 'app',

  components: {
    rodape,
    BotaoIrParaTopo,
    AjaxIntercept,
    Loader,
    BarraNavegacao,
    BarraEvolucao,
    BarraMenu,
  },

  data() {
    return {
      routes: this.$router.options.routes,
      carregando: false,
    };
  },

  computed: {
    auth() {
      return this.$root.$data.isAuthenticated;
    },
    usuarioLogado() {
      return this.$store.state.usuarioLogado;
    },
    stepVisible() {
      return (
        this.$root.$data.isAuthenticated && this.$route.meta.stepNumber > 0
      );
    },
    number() {
      return this.$route.meta.stepNumber;
    },
    stepName() {
      return this.$route.meta.displayName;
    },
    avaliaVisited() {
      return this.$route.meta.avaliaActive;
    },
    declaraVisited() {
      return this.$route.meta.declaraActive;
    },
    recadastraVisited() {
      return this.$route.meta.recadastraActive;
    },
    formulariosVisited() {
      return this.$route.meta.formulariosActive;
    },
    feriasVisited() {
      return this.$route.meta.feriasActive;
    },
    valeAlimentacaoVisited() {
      return this.$route.meta.valeAlimentacaoActive;
    },
  },

  methods: {
    start(param) {
      setTimeout(() => {
        if (param.readyState != 4) this.carregando = true;
      }, 1000);
      return;
    },

    finish(param) {
      let response = {};
      let message = '';
      const { status, responseType, timeout } = param;

      // Verifica se é uma requisição de serviço de CEP de várias maneiras
      const isCepRequest = 
        // Verifica pelo cabeçalho personalizado
        (param.requestHeaders && param.requestHeaders['X-Request-Type'] === 'cep-service') ||
        // Verifica pela URL - ViaCEP
        (param.responseURL && param.responseURL.includes('viacep.com.br/ws/')) ||
        // Verifica pela URL - BrasilAPI
        (param.responseURL && param.responseURL.includes('brasilapi.com.br/api/cep/')) ||
        // Verifica pela URL - ApiCEP
        (param.responseURL && param.responseURL.includes('apicep.com/file/apicep/'));

      // Ignora completamente erros de conexão para requisições de CEP
      if (isCepRequest && (status === 0 || status >= 400)) {
        this.carregando = false;
        return;
      }

      if (
        (responseType == '' || responseType == 'text') &&
        param.responseText != ''
      ) {
        try {
          response = JSON.parse(param.responseText);
          message = response.message ? response.message.toLowerCase() : '';
        } catch (e) {
          // Ignora erros de parsing JSON
        }
      }

      if (status === 200 || status === 201 || status === 204 || status === 400) {
        this.carregando = false;
        return;
      }

      if (status === 401 && message === 'token expirou') {
        this.$root.$refs.toastr.e('Faça login novamente', 'Conexão expirou');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 401 && message === 'autenticação falhou') {
        this.$root.$refs.toastr.e('Usuário ou senha inválidos', 'Atenção');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 401 && message === 'usuário ou senha inválidos') {
        this.$root.$refs.toastr.e(
          'Usuário ou senha inválidos. Se o erro persistir, por favor, abra um SAU.',
          'Atenção',
        );
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 401) {
        this.$root.$refs.toastr.e(response.message, 'Atenção');
        this.$root.$data.isAuthenticated = false;
        this.$store.commit('setToken', '');
        this.$router.push('/');
        this.carregando = false;
        return;
      }

      if (status === 403) {
        this.$root.$refs.toastr.e(
          'Por favor, contate o administrador',
          'Sem acesso',
        );
        this.$router.push({ name: 'SemAcesso' });
        this.carregando = false;
        return;
      }

      if (status === 404 || status === 405) {
        this.carregando = false;
        if (param.responseURL.substr(-24, 13) === '/dependentes/') return;
        this.$root.$refs.toastr.e(
          'Recurso ou página não encontrado',
          'Atenção',
        );
        return;
      }

      if (status === 500) {
        const overlay = document.querySelector('.modal-backdrop');
        if (overlay) {
          overlay.remove();
        }
        this.$router.push({ name: 'Manutencao' });
        this.carregando = false;
        return;
      }

      if (status === 503) {
        this.$router.push({ name: 'Manutencao' });
        this.carregando = false;
        return;
      }

      if (status >= 500) {
        this.$root.$refs.toastr.e(
          'Contate o Administrador',
          'Problemas no Servidor',
        );
        this.$router.push({ name: 'SemAcesso' });
        this.carregando = false;
        return;
      }

      if (status === 0 && timeout === 0) {
        this.$root.$refs.toastr.w(
          'Verifique sua conexão de rede',
          'Computador sem conexão',
        );
        this.carregando = false;
        return;
      }
    },
  },

  mounted() {
    this.$root.$refs.toastr.defaultPreventDuplicates = true;
    this.$root.$refs.toastr.defaultPosition = 'toast-top-center';
    // this.$forceUpdate()
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans|Open+Sans:600|Open+Sans:700|Open+Sans:800');
@import '~vue-directive-tooltip/css/index.css';

.toast {
  opacity: 1 !important;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.3) !important;
}

* {
  box-sizing: border-box;
}

body,
input,
textarea,
select,
button {
  direction: ltr;
  font-feature-settings: 'kern';
  text-align: left;
}
body {
  font-family: 'Open Sans', helvetica, sans-serif;
  text-rendering: optimizelegibility;
  color: #697473;
  font-size: 1.4rem;
  line-height: 1.42857143;
  margin: 0;
  display: block;
  padding-top: 53px;
  position: relative;
  min-height: calc(100vh - 70px);
}
html {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a,
a:visited {
  text-decoration: none;
  color: #a1be4d;
}
a:hover,
a:focus {
  text-decoration: none;
  color: #00615c;
}
.row-field {
  padding-left: 15px;
  padding-right: 15px;
}
.main-container .container {
  position: relative;
}
.container-top {
  padding-top: 20px;
}
.card {
  background: #ffffff;
  border: 1px solid rgba(65, 76, 76, 0.2);
  box-shadow: 0 2px 2px 1px #d8d8d8;
  border-radius: 8px;
  overflow: hidden;
  /* transition: all 180ms ease 0s; */
}
.card-default {
  color: #697473;
  margin-bottom: 20px;
}
.card-default h3,
h4,
h4 > small {
  color: #00615c;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 20px;
}
.card-default h3 {
  font-size: 1.2rem;
}
.card-default h4 {
  font-size: 1.9rem;
}
.card-content {
  padding: 0px 20px;
}
.sub-card {
  margin: 0px 15px 15px;
  box-shadow: none;
}
.sub-card-content {
  padding: 0px 20px;
}
.sub-card-content-title {
  color: #00615c;
  font-weight: bold;
  font-size: 1.2em;
  line-height: 3em;
}
.sub-card-content-title small {
  color: #00615c;
  font-weight: bold;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Form button */
.btn:focus,
.btn:active:focus {
  outline: none;
}
.btn-lg {
  border-radius: 8px;
}
.btn-sm {
  border-radius: 6px;
  width: 40px;
}
.btn-danger,
.btn-default,
.btn-info,
.btn-primary,
.btn-success,
.btn-warning {
  text-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  background-image: none;
}
.btn-default {
  background: transparent;
  color: #959595;
  border: 2px solid;
  border-radius: 6px;
  font-weight: 400;
  text-transform: uppercase;
}
.btn-default:hover,
.btn-default:hover:focus {
  background: transparent;
  border: 2px solid;
  color: #63605d;
  text-transform: uppercase;
}
.btn-default:active,
.btn-default:focus,
.btn-default:target,
.btn-default:active:focus {
  background: #959595;
  border-color: #3d3d3d;
  color: #fff;
}
.btn-danger {
  background: transparent;
  border: 2px solid;
  border-radius: 6px;
  color: #8c1e26;
}
.btn-danger:hover {
  background: transparent;
  border: 2px solid;
  color: #bb8261;
}
.btn-primary {
  background: transparent;
  color: #468b35;
  border: 2px solid;
  border-radius: 6px;
  font-weight: 400;
  text-transform: uppercase;
}
.btn-primary:hover,
.btn-primary:hover:focus {
  background: transparent;
  border: 2px solid;
  color: #a1be4d;
  text-transform: uppercase;
}
.btn-primary:active,
.btn-primary:focus,
.btn-primary:target,
.btn-primary:active:focus,
.btn-primary:active:hover {
  background-color: #468b35;
  border-color: #0c635c;
  color: #fff;
}
.btn-warning {
  background: transparent;
  color: #ff9a03;
  border: 2px solid;
  border-radius: 6px;
  font-weight: 400;
  text-transform: uppercase;
}
.btn-warning:hover,
.btn-warning:hover:focus {
  background: transparent;
  border: 2px solid;
  color: #ffd699;
  text-transform: uppercase;
}
.btn-warning:active,
.btn-warning:focus,
.btn-warning:target,
.btn-warning:active:focus {
  background-color: #ff9a03;
  border-color: #af6b05;
  color: #fff;
}
.side-btn-default {
  background-color: #dddddd;
  border-color: #dddddd;
  color: #777777;
}
.side-btn-default:hover {
  background-color: #ffffff;
  border-color: #777777;
  color: #777777;
}
.side-btn-primary {
  background-color: #468b35;
  border-color: #468b35;
  color: #ffffff;
}
.side-btn-primary:hover {
  background-color: #ffffff;
  border-color: #468b35;
  color: #468b35;
}
.btn-primary:disabled,
.btn-primary[disabled]:hover {
  background-color: #9cc993;
  border-color: #9cc993;
  color: #ffffff;
}
.btn-next {
  float: right;
  margin-left: 15px;
}
.btn-previous {
  float: left;
}
.btn-success {
  color: #d7e7d7;
  border-color: #3e8f3e;
  background-color: #419641;
}
.btn-success:hover {
  color: #d7e7d7;
  border-color: #358a3f;
  background-color: #3d873d;
}
.btn-subscribe {
  display: block;
  margin: 20px auto 20px auto;
}
.btn-print {
  margin-top: 60px;
  margin-bottom: 60px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.btn-inline {
  float: right;
  margin-top: 24px;
}

/* Tooltip */
.vue-tooltip.tooltip-custom {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.7);
  max-width: 150px;
  text-align: center;
  z-index: 1000;
}
.vue-tooltip.tooltip-custom .tooltip-arrow {
  opacity: 0.7;
}
.disabled-tooltip {
  float: right;
}

/* Outros */
.carregando {
  text-align: center;
  padding-bottom: 20px;
  font-size: 26px;
}
.alert-warning {
  color: #ff9a03;
  background-color: #fcf2e6;
  border-color: #fae1cc;
}
.situacao-pendente {
  background-color: #fcf2e6 !important;
  color: #ff9a03;
}
.textoAlinhadoAoInput {
  padding-top: 8px;
}
.paragrafosPertoDeInput {
  margin-bottom: 7px;
}

/* Botões largos para mobile (405px é aprox. a medida de 3 botões) */
@media screen and (max-width: 405px) {
  .modal-footer .btn + .btn {
    margin-left: 0px;
    margin-bottom: 15px;
  }
  .btn-primary,
  .btn-next,
  .btn-previous,
  .side-btn-default,
  .side-btn-primary,
  .btn-subscribe {
    width: 100%;
    margin-bottom: 15px;
  }
  .btn-sm {
    width: 40px;
  }
  .footer-controller {
    padding-left: 30px;
    padding-right: 30px;
  }
  .footer-controller-inner {
    padding-bottom: 5px !important;
  }
  .side-body {
    padding-bottom: 0 !important;
  }
  .side-footer {
    padding: 0 15px;
  }
  .disabled-tooltip {
    float: none;
  }
}

/* Form input */
input[type='checkbox'],
input[type='radio'] {
  width: 20px;
  height: 20px;
}
input.form-control {
  text-transform: uppercase;
}
.checkbox-inline {
  display: table-cell;
  padding-bottom: 10px;
}
.input-checkbox {
  position: unset !important;
  vertical-align: bottom;
}
.error {
  color: #8c1e26;
}
.form-control:focus {
  border: 1px solid #76cf76;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(22, 128, 111, 0.6);
}

/* Responsividade de Filtros de CRUD */
@media screen and (max-width: 425px) {
  .filter-element {
    padding-right: 0;
  }
}

/* Tables */
.table > tbody > tr > td {
  padding: 4px 8px;
  vertical-align: middle;
}
.table > tfoot {
  font-weight: 700;
}
.table-responsive {
  border: unset;
}
.td-btns {
  width: 107px;
}
.td-btns-alone {
  width: 86px;
  text-align: right;
}
.footer-controller {
  padding-bottom: 15px;
}
.footer-center {
  display: flex;
  justify-content: center;
}
.footer-controller-inner {
  padding-top: 0px;
  padding-bottom: 20px;
}
.footer-controller-inner-modal {
  padding-bottom: 10px;
}

@media screen and (min-width: 768px) {
  body {
    min-height: calc(100vh - 70px);
  }
  .td-btns-alone {
    text-align: unset;
  }
}

@media screen and (min-width: 992px) {
  body {
    padding-top: 106px;
    min-height: calc(100vh - 70px);
  }
}
</style>



// WEBPACK FOOTER //
// Site.vue?de692522